// import * as Mixpanel from "mixpanel-browser";

import { actionCreator } from "../../../state/utils";
import { CreateActionCreator } from "../../../state/loading/actions";

export interface IIdentifyPayload {
  // TODO: Share these types with the backend
  user: {
    full_name: string;
    user_id: string;
    role: string;
    email: string;
    aviary_client: string;
    aviary_token: string;
    aviary_uid: string;
    aviary_user_details: string;
    feature_flags?: {
      enableTwilioVideo?: boolean;
    };
  };
  organization: {
    organization_name: string;
    organizational_code: string;
    activity: boolean;
    allow_dial_in: boolean;
    org_manager_view_all: boolean;
    aviary_export_allowed: boolean;
    permanent_org: {
      export_allowed: boolean;
      archive_nbr: string;
    };
    require_session_passwords: boolean;
    local_recordings_allowed: boolean;
    local_recordings_polyfill: boolean;
    created_at: string;
  };
}

export const IdentifyActionCreator = actionCreator<"IDENTIFY", IIdentifyPayload>("IDENTIFY");
export const ClearIdentityActionCreator = actionCreator<"CLEAR_IDENTITY">("CLEAR_IDENTITY");

export type ProfileActions = ReturnType<typeof IdentifyActionCreator> | ReturnType<typeof ClearIdentityActionCreator>;

export const FetchIdentity = CreateActionCreator("IDENTITY_LOADING", async (dispatch, getState) => {
  const authToken = getState().authV2.token;
  if (!authToken) {
    throw new Error("Auth token not set -- can't FetchIdentity");
  }

  const response = await fetch(`${getState().config.apiUrl}/current_user`, {
    headers: { authorization: authToken.access_token },
  });

  if (response.status !== 200) {
    throw new Error(await response.text());
  }

  const parsedResponse = await response.json();

  const orgInfo = parsedResponse.organization_info;
  delete parsedResponse.organization_info;

  dispatch(
    IdentifyActionCreator({
      user: parsedResponse,
      organization: orgInfo,
    })
  );
});
